module.exports = __webpack_public_path__ + "static/rcc-knb61-study-design-desktop-e894281435e2489147002f12d2af6e8a.png";